export const AUTOMATIC_PAYMENT_REMINDERS_MIN_DAYS = 1
